import { render, staticRenderFns } from "./generalRecovery.vue?vue&type=template&id=37da714e"
import script from "./generalRecovery.vue?vue&type=script&lang=js"
export * from "./generalRecovery.vue?vue&type=script&lang=js"
import style0 from "./generalRecovery.vue?vue&type=style&index=0&id=37da714e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports